module.exports = __webpack_public_path__ + "img/logo.0c69c38a.png";